/**
 * 企业
 */
<template>
  <div class="authentication">
    <div class="authentication-type" v-if="isAuthentication && active==0">
      <div class="authentication-type-item" :class="active==1?'authentication-type-active':''" @click="onAuthentication(2)">
        <div style="display: flex;align-items: flex-start;justify-content: space-between;">
          <div >
            <div class="authentication-type-item-name">
              <p>学生认证</p>
              <img src="../../assets/img/icon6.png" alt="">
            </div>
            <p class="authentication-type-item-text">请提前准备好学生证明材料，<br> 学校名称信息 </p>
          </div>
          <div class="authentication-type-item-icon">
            <img src="../../assets/img/icon16.png" alt="">
          </div>
        </div>
        <el-button  size="mini" type="warning" style="width: 200px;height: 40px;margin-top: 40px;background-color: #ff821c">开始认证</el-button>
      </div>
      <div class="authentication-type-item" :class="active==2?'authentication-type-active':''" @click="onAuthentication(1)">
        <div style="display: flex;align-items: flex-start;justify-content: space-between;">
          <div >
            <div class="authentication-type-item-name">
              <p>企业认证</p>
              <img src="../../assets/img/icon6.png" alt="">
            </div>
            <p class="authentication-type-item-text">
              请提前准备好企业邮箱账号，<br> 企业邀请码
            </p>
          </div>
          <div class="authentication-type-item-icon">
            <img src="../../assets/img/icon17.png" alt="">
          </div>
        </div>
        <el-button  size="mini" type="warning" style="width: 200px;height: 40px;margin-top: 40px;background-color: #ff821c">开始认证</el-button>
      </div>
    </div>
    <div class="form">
      <!-- 学生认证 -->
      <div class="e-form" v-if="active==2">
        <div style="margin-bottom: 26px;display: flex;align-items: center;" class="code">
          <h5>学生认证</h5>
          <p class="authentication-form-type" v-if="!userInfo.certificateName">未认证</p>
          <p class="authentication-form-type authentication-form-typel" v-else-if="ruleForm.checkState==0">认证中</p>
          <p class="authentication-form-type authentication-form-types" v-else-if="ruleForm.checkState==1">已认证</p>
          <p class="authentication-form-type authentication-form-types" v-else-if="ruleForm.checkState==2">已拒绝</p>
        </div>
        <p style="font-size: 13px; color: red;padding-bottom: 20px;" v-if="ruleForm.checkState==2">拒绝理由：{{ ruleForm.refuseReason }}</p>
        <div class="item">
          <p class="key"><span class="prop">*</span>学校名称：</p>
          <el-select v-if="!userInfo.certificateName || ruleForm.checkState==2" v-model="ruleForm.certificateName" filterable placeholder="请选择" style="width: 100%" @change="onCollege">
            <el-option
              style="font-size: 12px;"
              v-for="item in collegeList"
              :key="item.id"
              :label="item.collegeName"
              :value="item.id">
            </el-option>
          </el-select>
          <p class="val" v-else>{{ruleForm.certificateName}}</p>
        </div>
        
        <div class="item">
          <p class="key"><span class="prop">*</span>学生证</p>
          <p class="item-tisp" v-if="!userInfo.certificateImg">请上传您的学生证照片证明文件，提高过审几率~</p>
          <el-upload
            v-if="!userInfo.certificateImg || ruleForm.checkState==2"
            :action="uploadApi"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handSuccess"
            :limit="1"
            name='image'
            >
            <i class="el-icon-plus"></i>
          </el-upload>
          <img style="width: 6.3rem;" v-else :src="ruleForm.certificateImg">
        </div>
        <div class="but" v-if="!userInfo.certificateImg">
          <el-button :loading="loading" size="medium" type="warning" @click="submitCertification" style="background-color: #ff821c">提交认证</el-button>
          <el-button class="buttons" size="medium" @click="onCancel">取消认证</el-button>
        </div>
        <div class="but" v-else-if="ruleForm.checkState==2">
          <el-button  size="medium" :loading="loadings" type="warning" style="background-color: #ff821c" @click="submitCertification">重新认证</el-button>
        </div>
      </div>

      <!-- 企业认证 -->
      <div class="e-form" v-else-if="active==1">
        <div style="margin-bottom: 26px;display: flex;align-items: center;" class="code">
          <h5>企业认证</h5>
          <p class="authentication-form-type" v-if="!userInfo.certificateName">未认证{{ userInfo.certificateName }}</p>
          <p class="authentication-form-type authentication-form-typel" v-else-if="ruleForm.checkState==0">认证中</p>
          <p class="authentication-form-type authentication-form-types" v-else-if="ruleForm.checkState==1">已认证</p>
          <p class="authentication-form-type authentication-form-types" v-else-if="ruleForm.checkState==2">已拒绝</p>
        </div>
        <p style="font-size: 13px; color: red;padding-bottom: 20px;" v-if="ruleForm.checkState==2">拒绝理由：{{ ruleForm.refuseReason }}</p>
        <div class="item">
          <p class="key"><span class="prop">*</span>公司名称：</p>
          <el-input
            v-if="!userInfo.certificateName || ruleForm.checkState==2" 
            v-model="ruleForm.companyName" 
            placeholder="请在下方输入企业邀请码或邮箱匹配企业" 
            disabled>
          </el-input>
          <p class="val" v-else>{{ruleForm.certificateName}}</p>
        </div>
        <div class="item">
          <p class="key"><span class="prop">*</span>部门名称：</p>
          <el-input
            v-if="!userInfo.certificateName || ruleForm.checkState==2" 
            v-model="ruleForm.certificateRole" 
            placeholder="请输入部门名称" 
            >
          </el-input>
          <p class="val" v-else>{{ruleForm.certificateRole}}</p>
        </div>
        <div class="item">
          <p class="key">
            <span class="prop">*</span>
            认证方式：
            <span v-if="userInfo.certificateName" style="font-size: 11px;color: #9e9e9e;">{{ruleForm.certificateType==1?'企业邀请码':'邮箱'}}</span>
          </p>
          <div v-if="!userInfo.certificateName || ruleForm.checkState==2">
            <div class="authentication-form-radio">
              <el-radio v-model="radio" label="1" @input="onRadio('1')">企业邀请码</el-radio>
              <el-radio v-model="radio" label="2" @input="onRadio('2')">邮箱</el-radio>
            </div>
            <el-input v-model="ruleForm.socialCode" placeholder="请输入企业邀请码" @blur="getSearchList" v-if="radio=='1'"></el-input>
            <el-input v-model="companyMail" placeholder="请输入企业统一后缀邮箱" @blur="getSearchList" v-else></el-input>
          </div>
          <p class="val" v-else>{{ruleForm.certificateType==1?ruleForm.certificateCode:ruleForm.certificateMail}}</p>
        </div>
        <div class="item" v-if="radio=='1'">
          <p class="key"><span class="prop">*</span>证明材料</p>
          <p class="item-tisp" v-if="!userInfo.certificateImg || ruleForm.checkState==2">请上传您的工牌照片</p>
          <el-upload
            v-if="!userInfo.certificateImg || ruleForm.checkState==2"
            :action="uploadApi"
            list-type="picture-card"
            :on-remove="handleRemove"
            :on-success="handSuccess"
            :limit="1"
            name='image'
            >
            <i class="el-icon-plus"></i>
          </el-upload>
          <img v-else width="22%" :src="ruleForm.certificateImg">
        </div>
        <div style="margin-bottom: 36px;" class="code" v-if="radio=='2' && ruleForm.checkState != 2 && !userInfo.certificateName">
          <el-input v-model="ruleForm.mailCode" placeholder="请输入邮箱验证码"></el-input>
          <el-button size="small" type="warning" style="background-color: #ff821c" :loading="loadingl" @click="submitCode" :disabled="countdown > 0"> {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}</el-button>
        </div>
        <div style="margin-bottom: 36px;" class="code" v-else-if="radio=='2' && ruleForm.checkState == 2">
          <el-input v-model="ruleForm.mailCode" placeholder="请输入邮箱验证码"></el-input>
          <el-button size="small" type="warning" style="background-color: #ff821c" :loading="loadingl" @click="submitCode" :disabled="countdown > 0"> {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}</el-button>
        </div>
        
        <div class="but" v-if="ruleForm.checkState == -1">
          <el-button  size="medium" :loading="loadings" type="warning" style="background-color: #ff821c" @click="submitcompanyCertificate">提交认证</el-button>
          <el-button class="buttons" size="medium" @click="onCancel">取消认证</el-button>
        </div>
        <div class="but" v-else-if="ruleForm.checkState==2">
          <el-button  size="medium" :loading="loadings" type="warning" style="background-color: #ff821c" @click="submitcompanyCertificate">重新认证</el-button>
        </div>
      </div>
    </div>
  </div>
    
</template>

<script>
import {userInfo, collegeList , collegeCertificate, companySearch , companyCertificate ,getEmail} from '../../api/userMG'
export default {
  data() {
    return {
      userInfo:{},
      isAuthentication: true,
      type:1,
      active:0,
      collegeList:[],
      options: [{
          value: '黄金糕',
          label: '黄金糕'
        }, {
          value: '双皮奶',
          label: '双皮奶'
        }, {
          value: '蚵仔煎',
          label: '蚵仔煎'
        }, {
          value: '龙须面',
          label: '龙须面'
        }, {
          value: '北京烤鸭',
          label: '北京烤鸭'
        }],
      radio: '1',
      ruleForm: {
        checkState:'-1',
        certificateId:'',
        certificateName:'',
        certificateImg: '',
        certificateRole:'',
        companyName:'',
        certificateType:'',
        socialCode:'',
        companyMail:'',
        mailCode:''
      },

      dialogImageUrl: '',
      dialogVisible: false,
      loading:false,
      loadingl:false,
      countdown: 0, // 倒计时秒数
      intervalId: null, // 存储interval的id
      loadings:false,
      companyMail:''
    }
  },
  props: {
    userInfos: {
      type: Object,
      default: () => ({}),
    }
  },
  watch: {
    userInfos(newVal) {
      if (newVal) {
        this.init(); // 手动调用初始化方法
      }
    }
  },
  computed: {
    url() {
      return this.$store.getters.url;
    },
    uploadApi() {
      return this.$store.getters.uploadApi;
    }
  },
  /**
   * 创建完毕
   */
  created() {
    // this.getUserInfo();
    console.log("学校企业认证",this.userInfos)
    this.init();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    init() {
      console.log("init")
      if(this.userInfos.certificateUser){
        this.userInfo = this.userInfos.certificateUser;
        this.ruleForm = this.userInfos.certificateUser;
        this.active = this.userInfos.certificateUser.type;
        this.radio = this.userInfos.certificateUser.certificateType+'';
      }
      this.getCollegeList();
    },
    getUserInfo(){
      userInfo().then(res => {
        console.log("this.userInfo1111111",res.data)
        if(res.data.certificateUser){
          this.userInfo = res.data.certificateUser;
          this.ruleForm = res.data.certificateUser;
          this.active = res.data.certificateUser.type;
        }
      })
      .catch(err => {
        this.$message({
          type: 'error',
          message: '请求失败，请稍后再试！',
          offset:100
        })
      })
    },

    onButton(e){
      this.type = e
    },
    
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          deptSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '公司保存成功！',
                  offset:100
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg,
                  offset:100
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message({
                type: 'error',
                message: '公司保存失败，请稍后再试！',
                offset:100
              })
            })
        } else {
          return false
        }
      })
    },
    
    onAuthentication(e){
      this.isAuthentication = false;
      this.active = e;
    },

    // 获取学校
    async getCollegeList(){
      await collegeList().then(res => {
        console.log('学校列表',res.data);
        this.collegeList = res.data;
      })
      .catch(err => {
      })
    },

    onRadio(e){
      this.ruleForm.socialCode = '';
      this.companyMail = '';
      this.ruleForm.id = '';
      this.ruleForm.certificateImg = '';
    },

    // 获取企业
    async getSearchList(e){
      if(this.radio == 1 && !this.ruleForm.socialCode){
        this.$message({
          message: '请请入企业邀请码',
          type: 'warning',
          offset:100
        });
        return
      }
      if(this.radio == 2 && !this.companyMail){
        this.$message({
          message: '请请入企业邮箱',
          type: 'warning',
          offset:100
        });
        return
      }
      let params;
      if(this.radio==1){
        params={
          socialCode:this.ruleForm.socialCode
        }
      }
      if(this.radio==2){
        params={
          mail:this.companyMail
        }
      }
      await companySearch(params).then(res => {
        console.log('企业列表',res.data);
        this.ruleForm.companyName = res.data.companyName;
        this.ruleForm.id = res.data.id;
        this.ruleForm.socialCode = res.data.socialCode;
        // this.ruleForm.companyMail = res.data.companyMail;


        this.$forceUpdate()
      })
      .catch(err => {
        this.ruleForm.companyName = '';
        this.ruleForm.id = '';
      })
    },

    onCollege(id){
      console.log("选中学校id",id)
      this.ruleForm.certificateId = id
    },

    handSuccess(response, file, fileList) {
      this.ruleForm.certificateImg = file.response.data
    },
    handleRemove(file, fileList){
      this.ruleForm.certificateImg = ''
    },

    // 学生认证
    submitCertification(){
      if(!this.ruleForm.certificateId){
        this.$message({
          message: '请选择所在学校',
          type: 'warning',
          offset:100
        });
        return
      }
      if(!this.ruleForm.certificateImg){
        this.$message({
          message: '请上传相应证件照片',
          type: 'warning',
          offset:100
        });
        return
      }
      
      let ruleForm = {
        type:this.active,
        certificateId:this.ruleForm.certificateId,
        certificateImg:this.ruleForm.certificateImg
      };
      this.loading = true;
      collegeCertificate(ruleForm).then(res => {
        console.log('学生认证',res);
        if(res.code == 0){
          this.loading = false;
          this.$message({
            message: '提交成功！',
            type: 'success',
            offset:100
          });
          this.$emit("getUserInfo")
        }
      })
      .catch(err => {
        this.loading = false;
        // this.$message.error('请求失败，请稍后再试！')
      })
    },

    // 企业认证
    submitcompanyCertificate(){
      if(this.radio == 1 && !this.ruleForm.socialCode){
        this.$message({
          message: '请请入企业邀请码',
          type: 'warning',
          offset:100
        });
        return
      }
      if(this.radio == 2 && !this.companyMail){
        this.$message({
          message: '请请入企业邮箱',
          type: 'warning',
          offset:100
        });
        return
      }
      if(this.radio == 1 && !this.ruleForm.certificateImg){
        this.$message({
          message: '请上传相应证件照片',
          type: 'warning',
          offset:100
        });
        return
      }
      if(this.radio == 2 && !this.ruleForm.mailCode){
        this.$message({
          message: '请输入邮箱验证码',
          type: 'warning',
          offset:100
        });
        return
      }
      let ruleForm = {
        type:this.radio,
        code:this.radio=='1'?this.ruleForm.socialCode:this.ruleForm.mailCode,
        mailAddress:this.companyMail,
        companyId:this.ruleForm.id,
        certificateImg:this.ruleForm.certificateImg,
      };
      console.log('企业认证',ruleForm)
      this.loadings = true;
      companyCertificate(ruleForm).then(res => {
        console.log('学生认证',res);
        if(res.code == 0){
          this.loadings = false;
          this.$message({
            message: '提交成功！',
            type: 'success',
            offset:100
          });
          this.$emit("getUserInfo")
          this.$router.go(0);
        }
      })
      .catch(err => {
        this.loadings = false;
      })
    },

    // 取消认证
    onCancel(){
      this.isAuthentication = true
      this.active = 0;
      this.ruleForm = {};
      this.ruleForm.checkState = -1
    },

    submitCode(){
      if(!this.companyMail){
        this.$message({
          message: '请输入邮箱',
          type: 'warning',
          offset:100
        });
        return
      }
      let params = {
        email:this.companyMail
      }
      this.loadingl = true;
      getEmail(params).then(res => {
        console.log('验证码',res);
        this.loadingl = false;
        if(res.code==0){
          this.startCountdown(60);
        }
      })
      .catch(err => {
        this.loadingl = false
      })
    },

    startCountdown(seconds) {
      this.countdown = seconds;
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          clearInterval(this.intervalId);
        }
      }, 1000);
    }
  }
}
</script>

<style scoped>
  .authentication-type{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .authentication-type-item{
    border: 1px solid #f5f0ec;
    width: 40%;
    background-image: linear-gradient(bottom,#faf3ee,#fefefc);
    padding: 30px;
    border-radius: 2px;
    cursor: pointer;
  }
  .authentication-type-active{
    border: 1px solid #ffab68;
  }
  .authentication-type-item-name{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .authentication-type-item-name p{
    font-size: 17px;
    font-weight: 600;
    color: #ff821c;
    margin-right: 10px;
  }
  .authentication-type-item-name img{
    width: 15px;
  }
  .authentication-type-item-text{
    width: 180px;
    font-size: 12px;
    color: #989a99;
  }
  .authentication-type-item-icon img{
    width: 50px;
  }
  .authentication-form-type{
    padding: 2px 6px;
    border-radius: 3px;
    background: #e6e6e6;
    font-size: 11px;
    color: #b1b1b1;
    margin-left: 10px;
  }
  .authentication-form-types{
    background: #f68848;
    color: #fff;
  }
  .authentication-form-typel{
    background: #fff2e9;
    color: #f68848;
  }
  .el-radio-group{
    display: grid;
  }
  .authentication-form-radio /deep/ .el-radio__input.is-checked .el-radio__inner{
    border-color: #f15a01;
    background: #f15a01;
  }
  .authentication-form-radio /deep/ .el-radio__label{
    color: #b1b1b1;
  }
  .authentication-form-radio /deep/ .el-checkbox__inner{
    border-radius: 50%;
  }
  .authentication-form-radio /deep/ .el-radio{
    padding: 4px 0;
    margin: 10px 12px 10px 0;
  }
  .authentication-form-radio /deep/ .el-radio__label,.el-checkbox__label{
    font-size: 13px;
  }

  .form{
    margin:60px auto 0;
    width: 55%;
  }
  h5{
    border-left: 3px solid #ff821c;
    padding-left: 8px;
    border-radius: 2px;
  }
  .item{
    margin-bottom: 20px;
  }
  .code{
    display: flex;
    align-items: center;
  }
  .code .el-button--warning{
    padding:12px 28px;
  }
  .code /deep/ .el-input__inner{
    border-right: 0;
    
  }
  .el-input, .el-select{
    font-size: 12px;
  }
  .el-button--small{
    padding: 6px 18px;
  }
  .e-form .key{
    font-size: 12px;
    font-weight: 600;
    color: #666;
    margin-bottom: 6px;
  }
  .e-form .prop{
    color: #ff821c;
    margin-right: 2px;
  }
  .e-form .el-button--medium{
    padding: 14px 0px;
    width: 48%;
  }
  .but{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 50px;
  }
  .item-tisp{
    font-size: 11px;
    color: #9e9e9e;
    margin-bottom: 20px;
  }
  .item /deep/ .el-upload--picture-card{
    width: 90px;
    height: 90px;
    line-height: 100px;
  }
  .item /deep/ .el-input__inner{
    font-size: 12px;
  }
  .e-form .val{
    height: 40px;
    background: #f7f9fb;
    font-size: 12px;
    color: #424242;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-radius: 4px;
    margin-top: 10px;
  }
  .el-select-dropdown__item.selected{
    color: #f68848;
  }
  .item /deep/ .el-upload-list--picture-card .el-upload-list__item{
    width: 90px;
    height: 90px;
  }
</style>

 
 


// WEBPACK FOOTER //
// src/components/data/enterprise.vue